import { format } from "date-fns";

export const round = (value: number, precision: number) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

// Resolves a design-system token (e.g. "--primary", stored as "H S% L%") to a CSS color
// for libraries like ApexCharts that need a concrete value instead of var().
export const tokenColor = (name: string) =>
    `hsl(${getComputedStyle(document.documentElement).getPropertyValue(name).trim()})`;

export const formatLocalDate =(date: string, pattern: string) => {
    const dt = new Date(date);
    const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
    return format(dtDateOnly, pattern);
}
